import React, { useCallback, useContext } from 'react';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Link } from 'react-router-dom';
import ArrowrightIcon from 'icons/Arrowright.icon';
import { getDataRoomRoute } from 'utils';
import DataRoomContext from '../providers/DataRoom/DataRoom.context';
import { useTranslation } from 'react-i18next';
import useQuestionSubjects from './useQuestionSubjects';

export default function useAskQuestionDrawer() {
  const { popSuccess } = useContext(PopNotificationsContext);
  const {
    questionSubjects,
    dataRoom: { _id },
  } = useContext(DataRoomContext);

  const { questionSubjectsOptions } = useQuestionSubjects(questionSubjects);

  const { t } = useTranslation();

  const successNotification = useCallback(
    () =>
      popSuccess(
        <div className="qa-ask-question-drawer__success-notification">
          <p>{t('youQuestionWasSubmitted')}</p>
          <Link to={getDataRoomRoute(_id, 'questions/questions-and-answers')}>
            {t('viewAllYourQuestions')}
            <ArrowrightIcon />
          </Link>
        </div>,
      ),
    [_id, popSuccess, t],
  );

  return {
    questionSubjectsOptions,
    successNotification,
  };
}
